import { render, staticRenderFns } from "./tipheader.vue?vue&type=template&id=af6d6964&scoped=true&"
import script from "./tipheader.vue?vue&type=script&lang=js&"
export * from "./tipheader.vue?vue&type=script&lang=js&"
import style0 from "./tipheader.vue?vue&type=style&index=0&id=af6d6964&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6d6964",
  null
  
)

export default component.exports